<template>
  <Navbar />
  <ScrollButton />

  <!-- Banner -->
  <section
    class="banner-title"
    style="background-image: url(images/banner-cards.jpg)"
  >
    <div class="auto-container">
      <div class="row align-items-center justify-content-between">
        <div class="col-md-6 col-sm-6 col-xs-12 text-start">
          <h1>Kumanda ve Kontrol Kartları</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12 text-end">
          <nav aria-label="breadcrumb">
            <ol class="bread-crumb clearfix">
              <li><a href="/">Anasayfa</a></li>
              <li class="active" aria-current="page">Kumanda ve Kontrol Kartları</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </section>

  <!-- Açıklama Bölümü -->
  <section class="page-section" id="portfolio">
    <div class="container">
      <div class="text-uppercase line-wrapper">
        <div class="line"></div>
        <h2 class="text">Kart Tasarımlarımız</h2>
        <div class="line"></div>
      </div>

      <div class="row">
        <div class="col-lg-10 offset-lg-1 col-md-12 text-center">
           <h3 class="section-subtitle">Elektronik Sistemlerde Güçlü Tasarım ve Üretim</h3>
          <p>
            İntek olarak Bilişim Vadisi'nde, elektronik sistemler ve PCB tasarımı konusunda ileri teknoloji çözümleri sunuyoruz.
          </p>
<h3 class="section-subtitle">PCB ve Gömülü Sistem Uzmanlığı</h3>
          <p>
            Özelleştirilmiş kart tasarımı, gömülü yazılım geliştirme ve hızlı üretim kabiliyeti ile projelerinizi geleceğe taşıyoruz.
          </p>
<h3 class="section-subtitle">İnovasyon ve Müşteri Odaklılık</h3>
          <p>
            Her projeye özel çözümler üretip, kaliteli ve güvenilir kontrol sistemleri geliştiriyoruz.
          </p>
        </div>
      </div>
      <!-- Galeri -->
      <div class="row">
        <div class="text-uppercase line-wrapper mt-5">
          <h2 class="text">Galeri</h2>
          <div class="line"></div>
        </div>
 <div class="row image-gallery">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-10 mb-4"
          v-for="(item, index) in cards"
          :key="index"
        >
          <div class="portfolio-item">
            <a
              class="portfolio-link"
              data-bs-toggle="modal"
              :href="'#portfolioModal' + index"
            >
              <div class="portfolio-hover">
                <div class="portfolio-hover-content">
                  <font-awesome-icon icon="plus" />
                </div>
              </div>
      <img class="img-fluid"
        :src="item.logo"
        :alt="item.baslik || 'Kontrol Kartı Görseli'"  loading="lazy" decoding="async"
      />
            </a>
          </div>
        </div>
      </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <Footer />

  <!-- Modal Galeri -->
  <section
    class="portfolio-modal modal fade"
    v-for="(item, index) in cards"
    :key="index"
    :id="'portfolioModal' + index"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <button
          class="close-modal"
          type="button"
          data-bs-dismiss="modal"
          aria-label="Kapat"
        >
          <img src="images/close-icon.svg" alt="Kapat" />
        </button>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8">
              <div class="modal-body">
                <img
                  :src="item.logo"
                  :alt="item.baslik || 'Kontrol Kartı Detayı'" style="max-width: 100%; height: auto; border-radius: 8px;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted } from "vue";
import { useHead } from "@vueuse/head";
import { firestore } from "@/firebase/config";
import { query, collection, getDocs, where } from "firebase/firestore";

import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    Navbar,
    ScrollButton,
    Footer,
    FontAwesomeIcon,
  },
  setup() {
    const cards = ref([]);

    useHead({
      title: 'Kumanda ve Kontrol Kartları | İntek Electronic',
      meta: [
        {
          name: 'description',
          content: 'PCB tasarımı, gömülü sistem geliştirme ve kumanda kartlarında İntek Electronic uzmanlığı. Bilişim Vadisi’nde yüksek kaliteli çözümler.'
        },
        {
          name: 'keywords',
          content: 'kontrol kartları, kumanda kartları, pcb tasarımı, gömülü sistem, elektronik kart, bilişim vadisi, intek'
        },
        {
          property: 'og:title',
          content: 'Kumanda ve Kontrol Kartları | İntek Electronic'
        },
        {
          property: 'og:description',
          content: 'İleri teknolojiyle üretilmiş kontrol ve kumanda kartlarımızla tanışın. PCB ve yazılımda kaliteyi bir arada sunuyoruz.'
        },
        {
          property: 'og:image',
          content: 'https://www.intekelectronic.com.tr/images/banner-cards.jpg'
        },
        {
          property: 'og:url',
          content: 'https://www.intekelectronic.com.tr/kumanda-kontrol-kartlari'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.intekelectronic.com.tr/kumanda-kontrol-kartlari'
        }
      ]
    });

    onMounted(async () => {
      const q = query(collection(firestore, "kumandakontrol"), where("durum", "==", true));
      const querySnapshot = await getDocs(q);
      const veri = [];
      querySnapshot.forEach((doc) => {
        veri.push({ ...doc.data(), id: doc.id });
      });
      cards.value = veri;
    });

    return {
      cards,
    };
  },
};
</script>

<style scoped>
.portfolio-item {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 8px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.portfolio-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  border-radius: 4px;
}

.portfolio-item:hover img {
  transform: scale(1.05);
}

.portfolio-hover {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.portfolio-link:hover .portfolio-hover {
  opacity: 1;
}

.portfolio-hover-content {
  color: #fff;
  font-size: 2rem;
}
.portfolio-caption {
  text-align: center;
  margin-top: 0.5rem;
}
.section-subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #222;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}
p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 1.5rem;
  text-align: center;
}
.modal-body img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  display: block;
  margin: 0 auto;
}

@media (max-width: 768px) {
  p {
    font-size: 1rem;
    text-align: justify;
  }

  .section-subtitle {
    font-size: 1.1rem;
  }
}
@media (max-width: 768px) {
  .title-column h1 {
    font-size: 1.6rem;
    text-align: center;
  }
  .bread-crumb {
    justify-content: center;
    font-size: 0.9rem;
  }
}
</style>
